import slugify from 'slugify'

export function toSlug(value, options) {
  if (typeof value !== 'string' || value.trim() === '') return ''

  return options ? slugify(value, options) : slugify(value)
}
